
module.exports = require('./lib');




//////////////////
// WEBPACK FOOTER
// ./modules/socketapilegacy/~/socket.io-stream/index.js
// module id = 818
// module chunks = 0